import { appstr } from "../utils/appstr";
import { uFramelessPanelColor } from "../whitelabel/brand";
import { QAlert } from "./QAlert";
import { QRFC } from "./QRFC";
import { QWaitingPanel } from "./QWaitingPanel";
import { Globals } from "./Globals.js";

export class QLoadHeadersRFC extends QRFC {
  constructor() {
    super();
  }

  InitLoadHeaders(callbackObj, type, chartID, index, keys) {
    this.fType = type;
    this.fIndex = index;
    this.fKeys = keys; // Keys stores any non-standard headers. (ex. for ATS -> myMap)
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);

    var loadHeadersPanel = new QWaitingPanel();
    loadHeadersPanel.SetMsgColor(uFramelessPanelColor);
    loadHeadersPanel.AttachProcess(this);
    loadHeadersPanel.InitWaitingPanel(
      "Loading Headers" + "...",
      Globals._wsMgr.fBackgroundPanel,
      Globals._wsMgr,
      220
    );
    Globals._wsMgr.fWaiting = loadHeadersPanel;
  }

  GetCallName() {
    return "qmongorfc";
  }

  SetParams(orgName, userName, importData, chartID) {
    this.AddParameter("mode", "loadHeaders");
    this.AddParameter("org", orgName);
    this.AddParameter("user", userName);
    this.AddParameter("data", JSON.stringify(importData));
    this.AddParameter("chartID", chartID);
  }

  DoTransactionComplete(response, callBackObj) {
    if (Globals._wsMgr && Globals._wsMgr.fWaiting) {
      Globals._wsMgr.ClearAppLoadingAnimation();
    }

    Globals._timerMgr.ClearTimer();
    Globals._wsMgr.fWaiting = null;

    var r = JSON.parse(response);

    if (r["success"]) {
      callBackObj.ProcessHeaders(r);
    } else {
      var alert = new QAlert();
      var alertMessage = r["message"];
      alert.InitAlert(appstr("Alert"), alertMessage, null, Globals._wsMgr);
    }
    Globals._wsMgr.PrepRenderWS();
    Globals._wsMgr.RenderWS();
  }
}
